<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-sm-12">
        <h5 class="info-text">
          Select a Connection Point for Site
          <span class="span-site-name">{{ this.siteInformation.name }}</span>
        </h5>
      </div>
      <div class="col-sm-5">
        <label>Station</label>
        <fg-input :error="getError('station')">
          <el-select
            v-model="model.stationDetails"
            value-key="id"
            v-validate="modelValidations.station"
            class="select-primary"
            name="station"
            placeholder="Select Station"
            @change="getConnections($event)"
            no-data-text="No available Stations"
          >
            <el-option
              v-for="station in stations"
              class="select-primary"
              :label="String(station.station_number)"
              :value="station"
              :key="station.id"
              :disabled="station.disabled"
            >
              <span style="float: left">{{ station.station_number }}</span>
              <div v-if="station.disabled">
                <div v-if="station.status_description === 'INACTIVE'">
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    station.status_description
                  }}</span>
                </div>
                <div v-else>
                  <span style="float: right; color: #8492a6; font-size: 13px"
                    >UNAVAILABLE</span
                  >
                </div>
              </div>
            </el-option>
          </el-select>
        </fg-input>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-5">
        <label>Connection</label>
        <fg-input :error="getError('connection')">
          <el-select
            v-model="model.connectionDetails"
            value-key="id"
            v-validate="modelValidations.connection"
            class="select-primary"
            name="connection"
            placeholder="Select Connection"
            @change="sendConnectionIdToParent($event)"
            :disabled="Object.entries(model.stationDetails).length === 0"
          >
            <el-option
              v-for="connection in connections"
              class="select-primary"
              :label="connection.connection_point"
              :value="connection"
              :key="connection.id"
              :disabled="connection.disabled"
            >
              <span style="float: left">{{ connection.connection_point }}</span>
              <div v-if="connection.disabled">
                <div v-if="connection.status_description === 'INACTIVE'">
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    connection.status_description
                  }}</span>
                </div>
                <div v-else>
                  <span style="float: right; color: #8492a6; font-size: 13px"
                    >UNAVAILABLE</span
                  >
                </div>
              </div>
            </el-option>
          </el-select>
        </fg-input>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-5">
        <label>Cost/Hour:</label>
        <el-input
          placeholder="Please input"
          v-model="formattedCostPerHour"
          :disabled="true"
        ></el-input>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-5">
        <label>Start up cost:</label>
        <el-input
          placeholder="Please input"
          v-model="formattedStartUpCost"
          :disabled="true"
        ></el-input>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-sm-5">
        <label>Hours</label>
        <el-slider
          class="slider-primary"
          v-model="sliders.hours"
          @change="updateInputNumber"
        ></el-slider>
        <el-input-number
          v-model="model.inputHours"
          :step="1"
          :min="1"
          :max="99"
          step-strictly
          @change="updateSlider"
        ></el-input-number>
        <label
          >Either use the slider to enter number of hours or enter in the text
          field. Maximum hours should be 99.</label
        >
      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option, Slider, InputNumber, Input } from "element-ui";
import { EventBus } from "src/util/event-bus.js";
import HTTP from "src/util/http-common.js";

export default {
  name: "connection-details",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Slider.name]: Slider,
    [InputNumber.name]: InputNumber,
    [Input.name]: Input,
  },
  props: {
    siteId: {
      type: Number,
      required: true,
    },
    siteInformation: {
      type: Object,
      required: true,
    },
    stations: {
      type: Array,
      required: true,
    },
    isConnectionDetailsTab: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      model: {
        stationDetails: "",
        connectionDetails: "",
        inputHours: 1,
        costPerHour: 1,
        startUpCost: 1,
      },
      connections: [],
      modelValidations: {
        station: {
          required: true,
        },
        connection: {
          required: true,
        },
      },
      sliders: {
        hours: 1,
      },
    };
  },
  computed: {
    formattedCostPerHour() {
      return this.currencyFormatter().format(this.model.costPerHour);
    },
    formattedStartUpCost() {
      return this.currencyFormatter().format(this.model.startUpCost);
    },
  },
  watch: {
    isConnectionDetailsTab: function (newVal, oldVal) {
      if (newVal == false) {
        this.model.stationDetails = "";
        this.model.connectionDetails = "";
        this.$validator.errors.clear();
      }
    },
  },
  mounted() {
    EventBus.$on("reset-dropdown", () => {
      this.model.stationDetails = "";
      this.model.connectionDetails = "";
    });
  },
  methods: {
    getConnections(station) {
      const stationId = station.id;
      // call api here to fill connection dropdown
      HTTP.get(`api/v1/site/station/connection/list`, {
        params: {
          site_id: this.siteId,
          station_id: stationId,
          status: "free",
          is_purchasing: true,
        },
      })
        .then((response) => {
          this.connections = response.data;
        })
        .catch((err) => {
          alert(err);
        });
      this.model.connectionDetails = "";
    },
    updateSlider() {
      this.sliders.hours = this.model.inputHours;
    },
    updateInputNumber() {
      this.model.inputHours = this.sliders.hours;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },
    sendConnectionIdToParent(connectionDetails) {
      this.$emit("connection-change", connectionDetails.id);
    },
  },
};
</script>
<style scoped>
.span-site-name {
  text-transform: uppercase;
  color: #848484;
  white-space: nowrap;
}
</style>>
</style>
